import MessageModal from "@/components/modal/message-modal/message-modal";

type CompleteModalProps = {
  message: string;
};

const CompleteModal = ({ message }: CompleteModalProps) => {
  return (
    <MessageModal
      title={"Completed"}
      titleColor={"#22FF2D"}
      message={message}
    />
  );
};

export default CompleteModal;
